import { Parser } from '~/api';
import type { Modpack, ModpackBuild, ModpackBuildLogs } from '~/api/models';
import RequestService from './request';

interface IndexModpackRequest {
    platform: string;
    modpack_id: string;
}

class MinecraftModpacksService {
    getAll(req: PaginatableRequest): Promise<Modpack[]> {
        return RequestService.get('/minecraft-modpacks', req).then(Parser.parse);
    }

    index(data: IndexModpackRequest): Promise<void> {
        return RequestService.post('/minecraft-modpacks/index', data);
    }

    reindex(data: IndexModpackRequest): Promise<void> {
        return RequestService.post('/minecraft-modpacks/reindex', data);
    }

    get(): Promise<Modpack> {
        return RequestService.get('/minecraft-modpacks/:platform/:modpackId').then(Parser.parse);
    }

    getBuilds(req: PaginatableRequest): Promise<ModpackBuild[]> {
        return RequestService.get('/minecraft-modpacks/:platform/:modpackId/builds', req).then(Parser.parse);
    }

    getLogs(): Promise<ModpackBuildLogs> {
        return RequestService.get('/minecraft-modpacks/:platform/:modpackId/:versionId/logs').then(Parser.parse);
    }

    retryBuild(versionId: string): Promise<void> {
        return RequestService.post(`/minecraft-modpacks/:platform/:modpackId/${encodeURIComponent(versionId)}/retry`);
    }
}

export default new MinecraftModpacksService();
